module.exports = __webpack_public_path__ + "assets/media/evening.9cda92a4.mp3";